import React from 'react';

const SignaturePlaceDate = ({ date, address }) => {
  return (
    <div className="row justify-content-center">
      <div className="col-8">
        <div className="text-center" style={styles.title}>
          FECHA Y LUGAR DE LA FIRMA DEL PAGARE
        </div>
        <p className="text-center text-uppercase m-0">
          <b>
            {date} en {address}
          </b>
        </p>
      </div>
    </div>
  );
};

export default SignaturePlaceDate;

const styles = {
  title: {
    fontSize: '80%',
  },
};
